module.exports = __webpack_public_path__ + "static/media/gitlab.99196642.svg";